<template>
  <div>
    <a-form :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出库单号">
            <a-input :read-only="true" v-decorator="[
          'deliveryOrderNo',
          {initialValue:data.deliveryOrderNo}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单号">
            <a-input :read-only="true" v-decorator="[
          'orderNo',
          {initialValue:data.orderNo}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出库时间">
            <a-input :read-only="true" v-decorator="[
          'deliveryDate',
          {initialValue:formatDate(data.deliveryDate, 'YYYY-MM-DD')}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
            <a-input :read-only="true" v-decorator="[
          'contact',
          {initialValue:data.contact}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :read-only="true" v-decorator="[
          'telephone',
          {initialValue:data.telephone}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运输单号">
            <a-input :read-only="true" v-decorator="[
          'logisticsNo',
          {initialValue:data.logisticsNo}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车牌号">
            <a-input :read-only="true" v-decorator="[
          'licensePlate',
          {initialValue:data.licensePlate}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出库金额">
            <a-input :read-only="true" v-decorator="[
          'amount',
          {initialValue:data.amount}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-form-item :labelCol="{
        xs: { span: 24 },
        sm: { span: 2 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 22 }
      }" label="备注">
            <a-input :read-only="true" v-decorator="[
          'notes',
          {initialValue:data.notes}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="hp-manager-page-list">
      <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize=15 :dataSource="datas" :pagination="false" :loading="loading" @tableChange="tableChange">
      </standard-table>
    </div>
  </div>

</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  name: "hp-manager-page-deliveryorder-detail",
  mixins: [account, dateFormat, moneyFormat],
  props: {
    params: Object
  },
  data() {
    return {
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      columns: [
        {
          title: "产品编号",
          width: 120,
          dataIndex: "productCode",
          sorter: true
        },
        {
          title: "产品名",
          width: 230,
          dataIndex: "productName",
          sorter: true
        },
        {
          title: "规格",
          width: 160,
          dataIndex: "specDes"
        },
        {
          title: "出库数量",
          width: 100,
          dataIndex: "quantity"
        },
        {
          title: "出库单价",
          width: 100,
          dataIndex: "price"
        },
        {
          title: "备注",
          dataIndex: "notes"
        }
      ],
      data: {},
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      visible: false,
      permission: []
    };
  },
  async mounted() {
    this.permission = this.getPermission("DeliveryOrder");
    this.getDatas();
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas();
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas();
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas();
    },

    async getDatas() {
      this.loading = true;
      let data = await api.GetDeliveryOrder({
        deliveryId: this.params.id
      });
      this.data = data;
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Orders/DeliveryOrder/DetailList.vue